import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1ecca124"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "canvas-introduction",
  id: "canvas-introduction"
}
const _hoisted_2 = { class: "canvas-introduction-text" }
const _hoisted_3 = { class: "canvas-counter" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MelatiCounter = _resolveComponent("MelatiCounter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, [
        _createVNode(_component_MelatiCounter, {
          total: _ctx.statisticsTotals?.all
        }, null, 8, ["total"]),
        _createTextVNode(" verhalen toegevoegd ")
      ])
    ])
  ]))
}